(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stamped-widget-loader"] && !Shopify.designMode) return;
  try {
    const stampedSource = 'https://cdn1.stamped.io/files/widget.min.js';
  const stampedConfig = {
    apiKey: '7b10392c-edca-4b47-a830-27317f0874a4',
    sId: '337961',
  };

  const initStamped = () => {
    if (typeof window.StampedFn?.init !== 'function') return;
    if (window.__fabulaStampedInitialized) return;

    window.__fabulaStampedInitialized = true;
    window.StampedFn.init(stampedConfig);
  };

  const loadStamped = () => {
    const existingScript = document.querySelector('[data-stamped-widget]');

    if (existingScript) {
      initStamped();
      return;
    }

    const script = document.createElement('script');
    script.src = stampedSource;
    script.async = true;
    script.type = 'text/javascript';
    script.crossOrigin = 'anonymous';
    script.dataset.stampedWidget = 'true';
    script.addEventListener('load', initStamped, { once: true });
    document.head.appendChild(script);
  };

  const scheduleStampedLoad = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(loadStamped, { timeout: 2500 });
      return;
    }

    window.setTimeout(loadStamped, 1500);
  };

  if (document.readyState === 'complete') {
    scheduleStampedLoad();
  } else {
    window.addEventListener('load', scheduleStampedLoad, { once: true });
  }
  } catch(e) { console.error(e); }
})();

})();
